import React from 'react';
import PropTypes from "prop-types";
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {PAGES} from '../common/Shared';
import OfferDetails from './OfferDetails';
import Profile from './Profile';
import moment from 'moment';
import NoOfferFound from "../common/NoOfferFound";

const propTypes = {
	accepted: PropTypes.bool.isRequired,
	offer: PropTypes.object,
	showEdit: PropTypes.bool,
};

const defaultProps = {
	offer: undefined,
	showEdit: false,
};

const mapStateToProps = (state) => {
	return {
		accepted: state.app.accepted,
		offer: state.app.offer,
		showEdit: state.app.showEdit,
	};
};

class Conditions extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		window.scrollTo(0,0);
	}

	setCorrection() {
		return {
            offerGuid: this.props.offer.guid,
            workingTitle: this.props.offer.workingTitle,
            agencyFk: this.props.offer.agencyFk,
            startDate: moment(this.props.offer.startDate, 'YYYY-MM-DD').format('MM/DD/YYYY'),
            wage: Number(this.props.offer.hourlyRate) ? this.props.offer.hourlyRate.toFixed(2) : Number(0).toFixed(2),
            workLocationFk: this.props.offer.workLocationFk,
            hiringManager: [this.props.offer.hiringOfficialFirstName, this.props.offer.hiringOfficialLastName].filter(s => s).join(' '),
            hiringManagerPhone: this.props.offer.hiringOfficialPhone,
            hiringManagerEmail: this.props.offer.hiringOfficialEmail,
			recruiter: [this.props.offer.recruiterFirstName, this.props.offer.recruiterLastName].filter(s => s).join(' '),
            recruiterPhone: this.props.offer.recruiterPhone,
            recruiterEmail: this.props.offer.recruiterEmail
		};
	}

	render() {
		return (
			<React.Fragment>
				{this.props.offer && this.props.offer.guid ?
				<div>
					<Profile/>
					<section>
						<h2 className="headline">Conditions of employment - Offer details</h2>
						<div className="content">
							<p>Please review these details and contact the hiring manager and/or recruiter if you have any questions.</p>
							<div className="flex flex-wrap">
								<div className="flex1 direction-col info">
                                    <p><strong>Working Title:</strong> <span className="no-wrap">{this.props.offer.workingTitle}</span></p>
                                    <p><strong>Agency:</strong> <span className="no-wrap">{this.props.offer.agencyName}</span></p>
                                    <p><strong>Start Date:</strong> <span className="no-wrap">{moment(this.props.offer.startDate, 'YYYY-MM-DD').format('MM/DD/YYYY')}</span></p>
								</div>
								<div className="flex1 direction-col info">
                                    <p><strong>Hiring Manager:</strong> <span className="no-wrap">{[this.props.offer.hiringOfficialFirstName, this.props.offer.hiringOfficialLastName].filter(s => s).join(' ')}</span></p>
                                    <p><strong>Contact Info:</strong> <span className="no-wrap">{this.props.offer.hiringOfficialPhone}</span></p>
									<p><span className="no-wrap">{this.props.offer.hiringOfficialEmail}</span></p>
								</div>
								<div className="flex1 direction-col info">
                                    <p><strong>Recruiter:</strong> <span className="no-wrap">{[this.props.offer.recruiterFirstName, this.props.offer.recruiterLastName].filter(s => s).join(' ')}</span></p>
                                    <p><strong>Contact Info:</strong> <span className="no-wrap">{this.props.offer.recruiterPhone}</span></p>
									<p><span className="no-wrap">{this.props.offer.recruiterEmail}</span></p>
								</div>
							</div>
							<div>
								<div>
									<p>
										<strong>Work Location: </strong>
										{this.props.offer.workLocationDescription && `${this.props.offer.workLocationDescription}, `}
										{this.props.offer.workLocationAddress && `${this.props.offer.workLocationAddress}, `}
										{this.props.offer.workLocationCity && `${this.props.offer.workLocationCity}, `}
										{this.props.offer.workLocationState} {this.props.offer.workLocationZip}
									</p>
                                    <p><strong>Wage:</strong> ${Number(this.props.offer.hourlyRate) ? this.props.offer.hourlyRate.toFixed(2) : Number(0).toFixed(2)}</p>
								</div>
								<div>
                                    <strong>Employment Type:</strong>
                                    <p>{this.props.offer.careerScheduleText}</p>
								</div>
								<div>
                                    <p><strong>Probationary Period:</strong> {this.props.offer.probationaryPeriodText}</p>
								</div>

                                {this.props.offer.criminalHistoryCheckText ?
                                    <div>
                                        <p><b>Criminal History</b></p>
                                        <p> {this.props.offer.criminalHistoryCheckText}</p>
                                    </div> : undefined
                                }

                                {this.props.offer.drugTestingText ?
                                    <div>
                                        <p><b>Drug Testing</b></p>
                                        <p> {this.props.offer.drugTestingText}</p>
                                    </div> : undefined
                                }

                                {this.props.offer.licenseText ?
                                    <div>
                                        <p><b>Licensees / Certification </b></p>
                                        <p> {this.props.offer.licenseText}</p>
                                    </div> : undefined
                                }



								<div>
									<strong>Other Condition:</strong>
									<p>This is only the first step of the offer acceptance process. Within one day of completing these steps, you will receive another email asking you to complete two onboarding tours. Please follow the instructions in the second email to complete the offer acceptance process.</p>
									<p>{this.props.offer.otherConditionText}</p>
								</div>
							</div>
							{this.props.showEdit ? <OfferDetails {...this.props} /> : undefined}
						</div>
					</section>

					<section>
						<h2 className="headline">Benefits Eligibility</h2>
						<div className="content">
							<p><strong>Benefits Eligibility:</strong></p>
							<p>{this.props.offer.benefitsText}</p>
						</div>
					</section>

					<section className="mb-spacing">
						<p><strong className="mb-spacing">After you have verified that the information entered above is correct, please select the "Acknowledge" button below.</strong></p>
						<Link to={`/${PAGES.DIRECT_DEPOSIT}/${this.props.offer.guid}`} className="button">
							Acknowledge Offer Details
						</Link>
					</section>
				</div> : <NoOfferFound/> }
			</React.Fragment>
		);
	}
}

Conditions.propTypes = propTypes;
Conditions.defaultProps = defaultProps;

export default connect(mapStateToProps)(Conditions);